import React from 'react';
import { cn } from '@hero/web-lib';
import { formatPlateForDisplay } from '../Select/SelectAsync/selectorEntityRowUtils';

export interface VehiclePlateDisplayProps {
  plate: string | undefined | null;
  className?: string;
}

/**
 * Saudi plate as one line: `KSZ | 1111 | م س ك` (same as `getVehiclePlateNumber().displayAll`).
 */
export function VehiclePlateDisplay({ plate, className }: VehiclePlateDisplayProps) {
  if (plate == null || String(plate).trim() === '') {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  const text = formatPlateForDisplay(String(plate));
  if (!text) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  return (
    <span className={cn('text-xs font-medium text-gray-900', className)} dir="auto">
      {text}
    </span>
  );
}
